import httpApi from '@vue3/utils/http-api'
import { api } from '@vue3/configs'

export default {
  saveNpsFeedback: (body) => {
    return httpApi.postDataViaApi({
      url: api.nps.saveNpsFeedback,
      body
    })
  },
  cancelNpsFeedback: (body) => {
    return httpApi.postDataViaApi({
      url: api.nps.cancelNpsFeedback,
      body
    })
  }
}
